import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";
import WaiterCallAlert from "./components/WaiterCallAlert";
import Login from "./pages/Login";
import Home from "./pages/Home";
import LiveOrders from "./pages/LiveOrders";
import CompletedOrders from "./pages/CompletedOrders";
import OnlineOrders from "./pages/OnlineOrders";
import Cart from "./pages/Cart";
import OrderConfirmation from "./pages/OrderConfirmation";

function Tab({ children }) {
  return (
    <ProtectedRoute>
      <MainLayout>{children}</MainLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <CartProvider>
          <WaiterCallAlert />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Tab><Home /></Tab>} />
              <Route path="/live-orders" element={<Tab><LiveOrders /></Tab>} />
              <Route path="/completed-orders" element={<Tab><CompletedOrders /></Tab>} />
              <Route path="/online-orders" element={<Tab><OnlineOrders /></Tab>} />
              <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
              <Route path="/order-confirmation" element={<ProtectedRoute><OrderConfirmation /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
